import { config } from "../config";
import { authorizationHeader } from "../Helpers/Api";
import { sseObservable } from "../Helpers/SSEObservable";

export const notificationsHandle = sseObservable({url: config.url.NOTIFICATIONS + "/sse", headers: authorizationHeader()});
export const peopleChatHandle = sseObservable({headers: authorizationHeader()});
export const publicChatHandle = sseObservable({headers: authorizationHeader()});